'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var workVideo = function workVideo() {
  return import('@/page/microLesson');
};
var workVideoList = function workVideoList() {
  return import('@/page/microLesson/microLesson-list');
};
var workVideoDetail = function workVideoDetail() {
  return import('@/page/course/course-detail');
};
exports.default = [{
  path: '/workVideo',
  name: 'workVideo',
  component: workVideo,
  children: [{
    path: 'workVideo-list',
    name: 'workVideo-list',
    component: workVideoList
  }, {
    path: 'workVideo-detail',
    name: 'workVideo-detail',
    component: workVideoDetail
  }]
}];